var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcelExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 868.71 844.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #37b44a;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m680.55,418.93H59.86c-33.04,0-59.86,26.77-59.86,59.82v180c0,33.04,26.81,59.86,59.86,59.86h620.69c33.04,0,59.81-26.82,59.81-59.86v-180c0-33.04-26.77-59.82-59.81-59.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m261.62,0c-57.67,0-104.61,46.93-104.61,104.65v113.7c0,14.52,41.84,15.41,41.84,0v-113.7c0-34.64,28.2-62.76,62.85-62.76h271.34v185.3c0,57.71,46.98,104.65,104.65,104.65h189.13v408.19c0,34.64-28.12,62.81-62.81,62.81h-506.95c-20.29,0-19.74,41.88,0,41.88h506.95c57.75,0,104.69-46.93,104.69-104.69v-103.13h0v-334.78L562.55,0h-300.93Zm323.08,91.26l188.75,186.27h-135.33c-29.47,0-53.42-23.99-53.42-53.42V91.26Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m247.39,675.73l-19.16-38.32c-7.85-14.76-12.88-25.76-18.85-38h-.63c-4.4,12.25-9.74,23.24-16.33,38l-17.59,38.32h-54.65l61.25-107.1-59.05-104.59h54.96l18.53,38.63c6.28,12.88,10.99,23.24,16.02,35.18h.63c5.03-13.51,9.11-22.93,14.45-35.18l17.9-38.63h54.65l-59.68,103.33,62.82,108.36h-55.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m328.42,464.04h48.06v171.49h84.18v40.2h-132.23v-211.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m490.48,626.42c12.88,6.6,32.67,13.19,53.08,13.19,21.99,0,33.61-9.11,33.61-22.93s-10.05-20.73-35.49-29.84c-35.18-12.25-58.11-31.72-58.11-62.5,0-36.12,30.15-63.76,80.09-63.76,23.87,0,41.46,5.03,54.02,10.68l-10.68,38.63c-8.48-4.08-23.56-10.05-44.29-10.05s-30.78,9.42-30.78,20.42c0,13.51,11.94,19.47,39.26,29.84,37.38,13.82,54.96,33.29,54.96,63.13,0,35.49-27.33,65.64-85.43,65.64-24.18,0-48.06-6.28-59.99-12.88l9.74-39.58Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelExport);
export default __webpack_public_path__ + "static/media/excelExport.a854751afb48a8784d85ed6418b2d084.svg";
export { ForwardRef as ReactComponent };